import React, { useCallback, useState } from 'react';

import { Button } from '@/shared/ui';
import { SplitLayout } from '@/modules/onboarding/components/split-layout';
import { ExtendedAddress } from '@/shared/components/address-form/types';
import { ICustomersUserAddressesResponse } from '@/shared/endpoints/customers';
import MainAddressForm, { AddressFormVariant } from '@/shared/components/address-form';

import AddressIllustration from './components/AddressIllustration';
import AddressSideComponent from './components/AddressSideComponent';

interface AboutYouAddressFormProps {
    onFormSubmit: (values: ExtendedAddress, formVariant: AddressFormVariant, passThrough?: boolean) => void | Promise<void>;
    onGoBack: () => void;
    defaultValues?: ICustomersUserAddressesResponse;
    loading: boolean;
    showMakeAsDefault?: boolean;
    autoDefault?: boolean;
    isManualForm?: (val: boolean) => void;
    showBackButton?: boolean;
}

interface AboutYouAddressProps {
    formArttributes: AboutYouAddressFormProps;
}

const AboutYouAddress: React.FC<AboutYouAddressProps> = props => {
    const { loading, onFormSubmit, autoDefault, onGoBack, defaultValues } = props.formArttributes;
    const [formVariant, setFormVariant] = useState<'auto' | 'manual'>('auto');

    const handleSubmit = useCallback(
        (address: ExtendedAddress, formVariant: AddressFormVariant, skipApi: boolean) => {
            return onFormSubmit(address, formVariant, skipApi);
        },
        [onFormSubmit]
    );

    return (
        <SplitLayout
            sideContent={<AddressSideComponent />}
            mainContent={
                <div className="box-border flex w-full flex-1 flex-col items-center justify-start desktop-min:items-start">
                    <div className="box-wrapper desktop-min:box-wrapper-lg xl-min:box-wrapper-xl box-border w-full bg-white">
                        <MainAddressForm
                            visibleBackToAuto
                            manualFormTitle="Shipping Address"
                            loading={loading}
                            onVariantChange={setFormVariant}
                            onSubmit={handleSubmit}
                            autoDefault={autoDefault}
                            formVariant={formVariant}
                            defaultValues={defaultValues}
                            onGoBack={onGoBack}
                            withManualAddressDemo
                            withAutoAddressPreview
                            defaultLabelAndHidden='Home'
                        />
                        {formVariant === 'auto' && !defaultValues && (
                            <Button
                                onClick={onGoBack}
                                variant="outlined"
                                sx={{
                                    width: '100%',
                                    mt: 2
                                }}
                                testId="button-about-you-address-back"
                            >
                                Back
                            </Button>
                        )}
                    </div>
                    <div className="mb-[3rem] mt-[2rem] desktop-min:mb-0 desktop-min:mt-0 desktop-min:hidden">
                        <AddressIllustration />
                    </div>
                </div>
            }
        />
    );
};

export default AboutYouAddress;
